import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  featureFlags: null,
}

const getters = {
  featureFlags() {
    let url = `/Config/Features`
    return axios.get(url)
  },
}

export default class FeatureFlagsService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
